import React, { Component } from "react";

import Info from "../components/info/info";
import "../components/info/generalinfo.css";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getpath } from "../actions/get-path";
class GeneralInfo extends Component {
  componentDidMount() {
    this.props.getpath("Info", "info");
  }
  render() {
    return (
      <div>
        <Info />
      </div>
    );
  }
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators({ getpath: getpath }, dispatch);
}
export default connect(
  null,
  matchDispatchToProps
)(GeneralInfo);



// WEBPACK FOOTER //
// ./src/containers/GeneralInfo.js